
import { TesCarousel } from '../components/TesCarousel'

import { Helmet } from 'react-helmet-async';
import './About.css'

function About() {
  const teamImages = [
    "https://www.kamerazofafrika.com/wp-content/uploads/teammember1.jpg",
    "https://www.kamerazofafrika.com/wp-content/uploads/teammember2.jpg",
    "https://www.kamerazofafrika.com/wp-content/uploads/teammember3.jpg",
    "https://www.kamerazofafrika.com/wp-content/uploads/teammember4.jpg",
  ];
  const teamImages1 = [
    "https://www.kamerazofafrika.com/wp-content/uploads/teammember5.jpg",
    "https://www.kamerazofafrika.com/wp-content/uploads/teammember6.jpg",
    "https://www.kamerazofafrika.com/wp-content/uploads/teammember7.jpg",

  ];
  return (
    <div className='d-flex flex-column justify-content-center align-items-center' style={{
      position: "relative",
      zIndex: 100,
      backgroundImage: "var(--bg-image)",
      backgroundAttachment: "fixed",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}>
      <Helmet>
        <title>About Us | African Travel Tour</title>
        <meta
          name="description"
          content="At African Travel Tour, we go beyond ordinary travel. Discover our story, our mission, and our passion for creating tailor-made safaris across Tanzania and East Africa."
        />
        <meta
          name="keywords"
          content="About African Travel Tour, safari company Tanzania, safari experts, travel agency East Africa"
        />
        <meta property="og:title" content="About Us | African Travel Tour" />
        <meta property="og:description" content="Learn more about African Travel Tour — your trusted safari experts in Tanzania and East Africa, crafting unforgettable travel experiences." />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://kamerazofafrika.com/about" />
      </Helmet>




      <div className="container-fluid bg-primary py-5 mb-5 about-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="section-header text-white animated slideInDown mb-4">
                About Us
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  {/* <li className="breadcrumb-item">
                <a href="/Pages">Pages</a>
              </li> */}
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    About
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className='aboutUs-Intro pb-5 wow fadeInUp'>
        <p className='accent mb-5 text-center'>Celebrating 10 Years of Unparalleled Experience  </p>
        <p className='' style={{
          color: '#7a3d3d', textAlign: "justify",
          textAlignLast: "center"
        }}>

          We love Africa. Our team of safari experts are all African born and raised. We’ve grown up on game reserves, worked as head rangers and lodge managers, and spend our own holidays on safari; we understand what goes into making every trip to Africa a once in a lifetime experience.
          <br />
          We are your full-service partner for your safari adventure. Our experienced Safari Experts match your preferences and budget to carefully selected lodges and activities - we can take care of your entire itinerary.

        </p>
        <h2 className="section-header my-5 text-center headerToRemoveMobile">
          <span className="accent pulse-button">
            ‘We tell the african story through your lens.’
          </span>

        </h2>
      </div>

      <div
        className="container-fluid py-5 px-5"

      >
        <div className="row align-items-center justify-content-center position-relative">
          {/* Left Section */}
          <div className="col-md-5 text-center mb-5 mb-md-0 d-flex flex-column align-items-center">
            <img
              src="https://redlionandcompany.com/Assets/kamarezOfArica/aboutAfrican2.png"
              alt="Dubai Safari"
              className="img-fluid"
              style={{ borderRadius: "12px" }}
            />
            <div style={{ maxWidth: "600px" }}>
              <h2 className="section-header mt-4">
                <span className="accent pulse-button">
                  Our Story
                </span>
                <br />

              </h2>

              <p className='' style={{
                color: '#7a3d3d', textAlign: "justify",
                textAlignLast: "center"
              }}>
                African Travel Tour is a tour, travel and safari company legally incorporated in Tanzania and operating in the entire East Africa. We offer Wildlife safaris, Gorilla Safaris, Bird Watching Safaris, Mountain Hiking, Chimpanzee trekking, Cultural Tours, Guided Nature walks, airport transfers and Customized Tours in Tanzania.

                We also offer wildlife safaris and tours to Uganda, Kenya and Rwanda. Our staff are professional and knowledgeable with the various tourist destinations in Tanzania and they handle a visitor with utmost customer care right from the stage of a service inquiry up to the accomplishment of the trip.

              </p>
            </div>
          </div>


          <div className="col-md-2 d-flex align-items-center justify-content-center">
            <img
              src="https://redlionandcompany.com/Assets/kamarezOfArica/elephanticon.png"
              alt="Amazon Forest"
              className="img-fluid mt-4"
              style={{ borderRadius: "12px", opacity: 0.1 }}
            />
          </div>

          {/* Right Section */}
          <div className="col-md-5 text-center d-flex flex-column align-items-center">
            <div style={{ maxWidth: "600px" }}>
              <h2 className="section-header mt-4">
                <span className="accent pulse-button">
                  Why Choose Us ?
                </span>
                <br />

              </h2>
              <div className='' style={{
                color: '#7a3d3d', textAlign: "justify",
                textAlignLast: "center"
              }}>
                <p >
                  <span className='bi bi-star-fill me-2'></span> Personalized Itineraries: Your trip is designed around your interests,
                  whether it’s wildlife, culture, adventure, or relaxation.
                </p>
                <p >
                  <span className='bi bi-star-fill me-2'></span> Flexibility: Choose your travel dates, destinations, and activities
                  without being tied to fixed group schedules.
                </p>
                <p >
                  <span className='bi bi-star-fill me-2'></span> Expert Guidance: Our safari experts work closely with you to create a
                  seamless and unforgettable experience.
                </p>
                <p >
                  <span className='bi bi-star-fill me-2'></span> Exclusive Experiences: Access hidden gems and unique activities that
                  aren’t available on standard tours.

                </p>
              </div>


            </div>
            <img
              src="https://redlionandcompany.com/Assets/kamarezOfArica/aboutAfrican1.png"
              alt="Amazon Forest"
              className="img-fluid  mt-4"
              style={{ borderRadius: "12px" }}
            />
          </div>
        </div>
      </div>

      {/*  */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center my-5 pb-4  ">
            <h2 className="section-header">
              <span className="accent pulse-button">
                Our Team
              </span>
              <br />
              Meet The Dream Team
            </h2>
          </div>

          <div className='d-flex align-items-center justify-content-center '>
            <img loading="lazy" src="https://africantraveltour.com/assets/img/about-sec-aftt-3.webp" alt="team" className="img-fluid" style={{ borderRadius: '50px' }} />
          </div>
        </div>
      </div>




      {/* Testimonial Start  */}



      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="text-center my-5">
            <h2 className="section-header">
              <span className="accent pulse-button">
                Testimonials
              </span>
              <br />
              Our Clients Say !
            </h2>
          </div>

          <div className="d-flex align-items-center justify-content-center">
            <TesCarousel />
          </div>
        </div>
      </div>

      {/*Testimonial End */}

    </div>
  )
}

export default About